<template>
  <div class="animated fadeIn">
    <component-header
      title="Items"
      @search-query="(val) => (filter = val)"
      :isLoading="isloader"
      @reload-data="refreshAllDataItem"
      :hasCreate="false"
      :hasback="true"
      @back-press="goToViewPage"
    />
    <b-row>
      <b-col>
        <b-card
          border-variant="info"
          header-bg-variant="primary"
          header-text-variant="white"
          style="min-height: 450px"
        >
          <b-row>
            <b-col md="2" class="my-1">
              <b-form-group label-cols-sm="3" class="mb-0">
                <b-form-select :options="pageOptions" id="pagination" v-model="perPage" />
              </b-form-group>
            </b-col>

            <b-col
              md="3"
              class="my-1"
              v-if="$userRole === 'Partner' && segmentType === 'MARKET'"
            >
              <b-form-group class="mb-0">
                <eb-select
                  type="select"
                  v-model="selectedMarketId"
                  :options="marketList"
                  label="text"
                  :id="'selectMarket'"
                  placeholder="Select Market"
                  @input="onChangeMarket"
                ></eb-select>
              </b-form-group>
            </b-col>

            <b-col md="3" class="my-1" v-if="$userRole === 'Partner'">
              <b-form-group class="mb-0">
                <eb-select
                  type="select"
                  v-model="selectedMarketCategoryId"
                  :options="marketCategory"
                  label="text"
                  :id="'selectcategory'"
                  placeholder="Select Category"
                  @input="onChangeCategory"
                ></eb-select>
              </b-form-group>
            </b-col>

            <b-col md="3" class="my-1">
              <b-form-group class="mb-0">
                <eb-select
                  type="select"
                  v-model="catalogSelectedID"
                  :options="catalogList"
                  label="text"
                  :id="'selectCatalog'"
                  placeholder="Select Product Catalog"
                  @input="catalogNameChange"
                ></eb-select>
              </b-form-group>
            </b-col>

            <b-col
              md="3"
              class="my-1"
              v-if="
                catalogSelectedID != 1 && userPermission.hasOwnProperty('CREATE_ITEM')
              "
            >
              <router-link :to="`item/create/${catalogSelectedID}`">
                <button class="mr-1 btn btn-primary" variant="facebook" id="createItem">
                  <i class="fa fa-plus"></i>
                  <span class="ml-1"><b>Create</b></span>
                </button>
              </router-link>
              <router-link :to="`item/bulk/create/${catalogSelectedID}`">
                <button
                  v-if="this.$userRole === 'Partner'"
                  class="mr-1 btn btn-primary"
                  variant="facebook"
                  id="createItem"
                >
                  <i class="fas fa-mail-bulk"></i>
                  <span class="ml-1"><b>Bulk Create</b></span>
                </button>
              </router-link>
            </b-col>
          </b-row>
          <b-table
            id="table-transition-example"
            :dark="dark"
            :hover="hover"
            :striped="striped"
            :bordered="bordered"
            :small="small"
            :fixed="fixed"
            responsive="sm"
            :items="items"
            :fields="captions"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            v-if="catalogSelectedID != 1 && !loading"
            class="mt-2"
            thead-class="header"
            primary-key="_id"
            show-empty
            :tbody-transition-props="transProps"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
          >
            <template slot="Price" slot-scope="data">{{ data.item.Price }}</template>
            <template slot="action" slot-scope="data">
              <router-link :to="{ name: 'ViewItem', params: { id: data.item._id } }">
                <b-button
                  v-if="userPermission.hasOwnProperty('VIEW_ITEM')"
                  size="sm"
                  class="mr-2"
                  variant="primary"
                  id="viewItem"
                >
                  <i class="fa fa-eye"></i>
                </b-button>
              </router-link>
              <router-link :to="{ name: 'EditItem', params: { id: data.item._id } }">
                <b-button
                  v-if="userPermission.hasOwnProperty('UPDATE_ITEM')"
                  size="sm"
                  class="mr-2"
                  variant="primary"
                  id="editItem"
                >
                  <i class="fa fa-pencil edit"></i>
                </b-button>
              </router-link>
              <b-button
                v-if="userPermission.hasOwnProperty('DELETE_ITEM')"
                size="sm"
                class="mr-2"
                id="deleteItem"
                variant="danger"
                @click="deleteItem(data)"
              >
                <i class="fa fa-trash bin"></i>
              </b-button>
              <b-button
                v-if="userRole === 'Tenant'"
                size="sm"
                id="copyItem"
                class="mr-2"
                variant="primary"
                @click="
                  $router.push({
                    name: 'CopyItem',
                    params: { id: data.item._id },
                  })
                "
              >
                <i class="fa fa-copy"></i> Copy Item
              </b-button>
              <b-button
                style="margin-top: 15px"
                size="sm"
                id="viewWeb"
                class="mr-2"
                variant="primary"
                @click="viewOnWeb(data.item._id)"
              >
                <i class="fa fa-podcast"></i> Live Product
              </b-button>
              <b-col md="auto">
                <c-switch
                  @change="(e) => offlineItem(data.item, data.index, e)"
                  onTitle="Online"
                  offTitle="Offline"
                  v-model="data.item.isOffline"
                  :value="false"
                  :uncheckedValue="true"
                  color="primary"
                  class="mx-2 mt-2"
                  variant="pill"
                >
                </c-switch>
              </b-col>
            </template>
          </b-table>
          <b-row v-show="catalogSelectedID != 1 && items.length > 0 && !loading">
            <b-col md="12">
              <nav class="float-right">
                <b-pagination
                  :total-rows="totalRows"
                  :per-page="perPage"
                  v-model="currentPage"
                  prev-text="Prev"
                  next-text="Next"
                  hide-goto-end-buttons
                />
              </nav>
            </b-col>
          </b-row>
          <b-row v-if="loading">
            <b-col md="6">
              <atom-spinner
                :animation-duration="1000"
                :size="60"
                color="#ff1d5e"
                class="float-right my-4"
              />
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import cTable from "../base/Table.vue";
import { mapState, mapGetters } from "vuex";
import { AtomSpinner } from "epic-spinners";
import loader from "@/components/loader/nipigeloader.vue";
import ebSelect from "@/components/FormElements/Select.vue";
import ComponentHeader from "@/components/componentHeader";
import { tenantWebsites } from "@/shared/tenantWebsites.config";
import { Switch as cSwitch } from "@/components/Switch";
import moment from "moment";
export default {
  name: "ViewItem",
  components: {
    cTable,
    AtomSpinner,
    ebSelect,
    loader,
    ComponentHeader,
    cSwitch,
  },
  data: () => {
    return {
      mymodalclass: ["mymodalclass"],
      transProps: {
        name: "flip-list",
      },
      showDismissibleAlert: false,
      loading: false,
      isloader: false,
      items: [],
      catalogSelectedID: "1",
      provider: "",
      catalogList: [
        {
          text: "Select Catalog",
          value: "1",
        },
      ],
      fields: [],
      filter: "",
      caption: "Table",
      hover: true,
      striped: false,
      bordered: true,
      small: false,
      fixed: false,
      tableData: [],
      valuesMap: {},
      isAddresscapture: false,
      itemObj: {},
      perPage: 5,
      pageOptions: [5, 10, 15, 20, 25, 30],
      currentPage: 1,
      dark: false,
      sortBy: "createdAt",
      sortDesc: true,
      marketList: [],
      marketCategory: [],
      segmentType: "",
      selectedMarketId: null,
      selectedMarketCategoryId: null,
    };
  },
  methods: {
    goToViewPage() {
      if (this.$route.fullPath == "/item") {
        this.$router.push({
          name: "Home",
        });
      } else {
        this.$router.push({
          name: "PartnerView",
          params: { id: this.$route.params.id, parentId: this.$route.params.parentId },
        });
      }
    },
    async offlineItem(item, index, value) {
      const payload = {
        data: {
          isOffline: value,
          itemIds: [item._id],
        },
      };
      const itemIndex = this.perPage * (this.currentPage - 1) + index;
      try {
        // this.items[itemIndex].isOffline = payload.data.isOffline;
        // this.$set(this.items[itemIndex], "isOffline", payload.data.isOffline);
        await this.$store.dispatch("item/offlineItem", payload);
      } catch (err) {
        // if failed revert it
        this.items[itemIndex].isOffline = !payload.data.isOffline;
      }
    },
    async viewOnWeb(productId) {
      const productURL = `${tenantWebsites[this.userTenantId].URL}/${productId}`;
      window.open(productURL, "_blank");
    },
    onChangeMarket(data) {
      console.log(data);
      let searchString = `parent=${data.value}`;
      this.$store.dispatch("catalog/fetchCatalogList", searchString).then((result) => {
        if (result.data.status === 1 && result.data.response.length > 0) {
          this.marketCategory = result.data.response.map((c) => ({
            text: c.name,
            value: c._id,
          }));
        }
      });
    },
    onChangeCategory(data) {
      let searchString = `parent=${data.value}`;
      this.$store.dispatch("catalog/fetchCatalogList", searchString).then((result) => {
        if (result.data.status === 1 && result.data.response.length > 0) {
          this.catalogList = result.data.response.map((c) => ({
            text: c.name,
            value: c._id,
          }));
        }
      });
    },
    async catalogNameChange(data) {
      if (data) {
        this.catalogSelectedID = data.value;
        this.loading = true;
        const { VIEW_ALL_ITEMS } = this.permissions;
        let condition = {
          provider: this.provider,
          catalogId: data.value,
        };
        if (this.userRole === "Tenant") {
          delete condition.provider;
        }
        await this.$store.dispatch("item/fetchItemsByCatalog", condition);
        let result = this.$store.getters["item/GetItemListByCatalog"];
        if (result.length > 0) {
          this.items = result.map((e) => {
            const { integer_attributes } = e;
            const { string_attributes } = e;
            if (integer_attributes) {
              integer_attributes.filter((eb, idex) =>
                eb.attribute_name === "Price"
                  ? (e.Price = eb.attribute_value)
                  : eb.attribute_name === "Stock"
                  ? (e.stock = eb.attribute_value)
                  : ""
              );
            }
            if (string_attributes) {
              string_attributes.filter((eb, idex) =>
                eb.attribute_name === "Brand" ? (e.Brand = eb.attribute_value) : ""
              );
            }
            return e;
          });
          this.setDefaultColumnsValue();
          if (this.items.length === 0) this.showDismissibleAlert = true;
          else this.showDismissibleAlert = false;
          this.fields = [];
          this.fields.push(
            {
              key: "Name",
              label: "Name",
              sortable: true,
            },
            {
              key: "Price",
              label: "Price",
              sortable: true,
            },
            {
              key: "Type",
              label: "Type",
              sortable: true,
            },
            {
              key: "productType",
              label: "Product Type",
              sortable: true,
            },
            {
              key: "Inventory",
              label: "Inventory",
              sortable: true,
            },
            {
              key: "IsSellable",
              label: "Is Sellable",
              sortable: true,
            }
          );
          result[0]["Brand"]
            ? this.fields.push({
                key: "Brand",
                label: "Brand",
                sortable: true,
              })
            : null;
          result.map((Obj) => {
            Obj.Name = Obj.string_attributes[0].attribute_value;
          });
          console.log("result[0]", result[0]);
          for (let key in result[0]) {
            if (
              typeof result[0][key] !== "object" &&
              this.fields.length < 6 &&
              key != "string_attributes[0].attribute_value" &&
              key != "_id" &&
              key != "tenant" &&
              key != "provider" &&
              key != "catalogId" &&
              key != "createdAt" &&
              key != "isDeleted" &&
              key != "updatedAt" &&
              key != "Lat" &&
              key != "Lng" &&
              key != "Country" &&
              key != "State" &&
              key != "City" &&
              key != "Area" &&
              key != "productType" &&
              key != "Type" &&
              key != "Inventory" &&
              key != "IsSellable" &&
              key != "AvgRating" &&
              key != "manufacturerId"
            ) {
              this.fields.push({
                key: key,
                label: key,
                sortable: true,
              });
            }
          }
          this.loading = false;
          this.fields.push({
            key: "action",
            label: "Action",
          });
        } else {
          this.loading = false;
          this.items = [];
        }
      } else {
        this.catalogSelectedID = 1;
        this.items = [];
        this.loading = false;
      }
    },
    async getCatalogName() {
      // this.loading = true;
      let condition = {
        provider: this.provider,
      };
      await this.$store
        .dispatch("catalog/findCatalogByProviderId", condition)
        .then((result) => {
          result.map((item) => {
            this.catalogList.push({
              text: item.catalogDescription.displayName,
              value: item._id,
            });
          });
          this.loading = false;
        });
    },
    setDefaultColumnsValue() {
      this.items.map((obj) => {
        if (!obj["Type"]) {
          obj["Type"] = "PRODUCT";
        }
        if (!obj["productType"]) {
          obj["productType"] = "NORMAL";
        }
        if (!["TRUE", "FALSE"].includes(obj["IsSellable"])) {
          obj["IsSellable"] = "TRUE";
        }
        if (!obj["Inventory"]) {
          obj["Inventory"] = "FALSE";
        } else {
          obj["Inventory"] === "1"
            ? (obj["Inventory"] = "TRUE")
            : (obj["Inventory"] = "FALSE");
        }
      });
    },
    async deleteItem(rowdata) {
      await this.$store.dispatch("item/fetchItemById", rowdata.item._id);
      let data = this.$store.getters["item/GetCurrentItemObject"];
      let result = data.response[0];
      this.itemObj = result;
      let keys = Object.keys(result);
      let typeSet = new Set(["String", "Number", "Object", "Array"]);
      let attributesMap = new Map([
        ["String", []],
        ["Number", []],
        ["Object", []],
        ["Array", []],
      ]);
      let valuesMap = result;
      result.attributeItems.forEach((item) => {
        if (item) {
          if (item.attributeName === "Address") {
            this.isAddresscapture = true;
          }
          let type = item.attributeValueType,
            name = item.attributeName;
          // check key value is allowed type
          if (typeSet.has(type)) {
            let attObj = {
              ...item,
              type,
              name,
            };
            attributesMap.set(type, attributesMap.get(type).concat([attObj]));
            if (type == "Array") {
              if (attObj.UIConcern === "Select") {
                let options = new Map(
                  attObj.attributeItems.map((a) => [
                    a._id,
                    {
                      label: a.attributeName,
                      value: a._id,
                    },
                  ])
                );
                // console.log('att : ', attObj, '\noptions : ', options, '\nprior value : ', valuesMap[name]);
                valuesMap[name] = valuesMap[name].map((o) => options.get(o));
              }
              if (attObj.UIConcern === "Object") {
                valuesMap[name] = valuesMap[name];
              }
              if (attObj.UIConcern === "Checkbox") {
                console.log("temp value map : ", valuesMap[name]);
                valuesMap[name] = valuesMap[name];
              }
            }
            if (["Number", "String"].includes(type)) {
              const addresses = {
                Number: "integer_attributes",
                String: "string_attributes",
              };
              const attributes = result[addresses[type]];
              const valueItem = attributes.find((pair) => pair.attribute_name == name);
              if (valueItem) {
                valuesMap[name] = valueItem.attribute_value;
              }
            }
          }
        }
      });
      this.attributesMap = attributesMap;
      this.valuesMap = valuesMap;
      let payload = {
        ...this.valuesMap,
        images: {
          icon: "",
          smallImage: "",
          bigImage: "",
        },
      };
      // Casting select fields
      Object.keys(this.valuesMap).forEach((key) => {
        let tempItem = this.valuesMap[key];
        if (
          Array.isArray(tempItem) &&
          tempItem.length > 0 &&
          tempItem[0] &&
          tempItem[0].value
        ) {
          console.log(tempItem);
          payload[key] = tempItem.map((v) => v.value);
        }
      });
      payload.string_attributes[0].attribute_value = payload.Name;
      payload.catalogId = this.itemObj.catalogId;
      delete payload.product_summary;
      delete payload.updatedAt;
      delete payload.createdAt;
      delete payload._id;
      delete payload.Title;
      delete payload.attributeItems;
      delete payload.string_attributes;
      delete payload.integer_attributes;
      delete payload.tags;
      payload.isDeleted = true;
      if (payload["Name"] === "") {
        payload["Name"] = this.itemObj.Name;
        payload["string_attributes[0].attribute_value"] = payload["Name"];
      }
      payload.images.icon = this.itemObj.product_summary.images.icon;
      payload.images.smallImage = this.itemObj.product_summary.images.smallImage;
      payload.images.bigImage = this.itemObj.product_summary.images.bigImage;
      // check for address Object if exist //////
      if (this.isAddresscapture) {
        payload.City = this.itemObj.Address.City;
        payload.Country = this.itemObj.Address.Country;
        payload.State = this.itemObj.Address.State;
        payload.Lat = this.itemObj.Address.Lat;
        payload.Lng = this.itemObj.Address.Lng;
        payload.Address = {
          Lng: payload.Lng,
          Lat: payload.Lat,
          City: payload.City,
          State: payload.State,
          Country: payload.Country,
          Address: this.itemObj.Address.Address,
        };
        payload.Area = payload.Address.Address;
      }
      let dataObj = { id: rowdata.item._id, object: payload };
      console.log(dataObj);
      this.$swal({
        title: "Delete this Item?",
        text: "Are you sure? You won't be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes, Delete it!",
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("item/updateItemById", dataObj)
            .then((result) => {
              this.$toasted.success("Item Deleted");
              let condition = {
                provider: this.provider,
                catalogId: this.catalogSelectedID,
              };
              if (this.userRole === "Tenant") {
                delete condition.provider;
              }
              this.$store.dispatch("item/fetchItemsByCatalog", condition);
              this.items = this.items.filter((obj) => obj._id !== rowdata.item._id);
            })
            .catch((err) => {
              this.$toasted.error("Item not deleted");
            });
        }
      });
    },
    async refreshAllDataItem() {
      this.isloader = true;
      this.provider = this.$store.getters["auth/getUserID"];
      if (this.userRole === "Tenant") {
        await this.$store.dispatch("catalog/fetchTenantCatalogTree");
        const result = await this.$store.getters["catalog/GetTenantCatalogTree"];
        this.catalogList = result
          .filter((Obj) => Obj.isProductType)
          .map((c) => ({ text: c.name, value: c._id }));
        this.catalogList.reverse();
        this.isloader = false;
      } else {
        await this.$store.dispatch("catalog/fetchPartnerCatalogTree");
        const result = await this.$store.getters["catalog/GetPartnerCatalogTree"];
        this.catalogList = result
          .filter((Obj) => Obj.isProductType)
          .map((c) => ({ text: c.name, value: c._id }));
        this.catalogList.reverse();
        this.isloader = false;
      }
    },
  },
  mounted: async function () {
    this.isloader = true;
    this.provider = this.$store.getters["auth/getUserID"];
    if (this.userRole === "Tenant") {
      if ((await this.$store.getters["catalog/GetTenantCatalogTree"].length) == 0) {
        await this.$store.dispatch("catalog/fetchTenantCatalogTree");
      }
      const result = await this.$store.getters["catalog/GetTenantCatalogTree"];
      this.catalogList = result
        .filter((Obj) => Obj.isProductType)
        .map((c) => ({ text: c.name, value: c._id }));
      this.catalogList.reverse();
      this.isloader = false;
    } else {
      this.$store.dispatch("partner/fetchPartnerMarketSegment").then((data) => {
        console.log(data);
        if (data.status === 1 && data.response.length > 0) {
          this.segmentType = data.response.some((obj) => obj.isMarket)
            ? "MARKET"
            : "CATEGORY";
          if (this.segmentType === "MARKET") {
            this.marketList = data.response.map((c) => ({
              text: c.name,
              value: c._id,
            }));
          } else {
            this.marketCategory = data.response.map((c) => ({
              text: c.name,
              value: c._id,
            }));
          }
        }
        const result = this.$store.getters["catalog/GetTenantCatalogTree"];
        this.catalogList = result.filter((Obj) => Obj.isProductType);
      });
      this.isloader = false;
    }
  },
  computed: {
    ...mapState("auth", ["permissions"]),
    userRole() {
      if (this.$store.getters["auth/getUserRole"]) {
        return this.$store.getters["auth/getUserRole"];
      } else {
        return JSON.parse(sessionStorage.getItem("userLogin"))["role"];
      }
    },
    userTenantId() {
      if (this.userRole === "Tenant") {
        return JSON.parse(sessionStorage.getItem("userLogin"))["_id"];
      }
      return JSON.parse(sessionStorage.getItem("userLogin"))["tenant"];
    },
    totalRows() {
      return this.items.length;
    },
    captions() {
      return this.fields;
    },
    userPermission() {
      return this.$store.getters["auth/getUserPermissions"];
    },
  },
};
</script>

<style scoped>
.mymodalclass > div {
  margin-top: 45px !important;
}

.text-center {
  text-align: center !important;
}

[data-font="20"] {
  font-size: 20px;
}

.edit {
  color: #ffffff !important;
}

.bin {
  color: white !important;
}
</style>
<style>
table.table-bordered > tbody > tr {
  /* text-transform: capitalize; */
  text-align: center;
}

table#table-transition-example .flip-list-move {
  transition: transform 1s;
}
</style>
